import { CurrencySymbol } from '@pubstack/common/src/currency'

export const removeTraillingSlash = (str: string) => (str.endsWith('/') ? str.slice(0, -1) : str)

/** allowing narrow no break space so the currencysymbol doesn't break */
export const displayWithCurrency = (value?: string | number, currencySymbol?: CurrencySymbol) => `${value ?? ''}${currencySymbol ? ` ${currencySymbol}` : ''}`.trim()

export function copyToClipboard(value: string): Promise<void> {
  return navigator.clipboard.writeText(value)
}

/**
 * fast hashing function
 * Warning : high collision rate, do not use in sensitive operations
 * @param s any string
 * @returns a 32 bit long number
 *
 * ref: Taken from Google Analytics' old domain name hashing function
 */
export const fastHash = (s: string) => {
  const largePrime = 0x9e3779b1
  let hashBase = 0xcafebabe
  for (let i = 0; i < s.length; i++) hashBase = Math.imul(hashBase ^ s.charCodeAt(i), largePrime)
  return (hashBase ^ (hashBase >>> 16)) >>> 0
}

export const isNumber = (value: string | null): boolean => !!value && !isNaN(Number(value))

export const formatJSON = (value: string, indentationSpaceCount: number = 2): string => {
  try {
    return JSON.stringify(JSON.parse(value), null, indentationSpaceCount)
  } catch (_e) {
    return value
  }
}
